import { useEffect, useState, useMemo } from 'react';
import { useCable } from '../hooks/cable';
import { useSession } from '../Context';
import DefaultFallback from './DefaultFallback';

const Connecting = ({ fallback, setState }) => {
  const { setCable, setOnline, addMessage } = useSession();
  const { subscribe, unsubscribe, disconnect, say } = useCable();
  const [connected, setConnected] = useState(undefined);
  const [subscription, setSubscription] = useState('');

  const channelActions = useMemo(
    () => ({
      onConnected({ reconnected }) {
        if (!reconnected) {
          setConnected(true);
        }
        setOnline(true);
      },
      onDisconnected({ willAttemptReconnect }) {
        if (!willAttemptReconnect) {
          setConnected(false);
        }
        setOnline(false);
      },
      onReceived(data) {
        addMessage(data);
      },
    }),
    [setOnline, addMessage],
  );

  useEffect(() => {
    if (connected === undefined) return;
    if (connected) {
      setCable({
        say: (action, params) => say(subscription, action, params),
        disconnect,
        unsubscribe: () => unsubscribe(subscription),
      });
    }
  }, [setCable, say, disconnect, unsubscribe, connected, subscription]);
  useEffect(() => {
    if (connected === undefined) return;
    if (connected) {
      setState('CONNECTED');
    }
  }, [setState, connected]);

  useEffect(() => {
    setSubscription(subscribe(channelActions));
  }, [subscribe, channelActions]);

  return fallback || <DefaultFallback />;
};

export default Connecting;
